import type { HelpFile } from '../../types/help'
import { OrganizationStepTestIds } from '../../../testids/OrganizationStepTestIds'

export const organizationStepHelp: HelpFile = {
  docPage: '/docs/onboarding/organization-step',
  texts: {
    [OrganizationStepTestIds.cardTitleManager]: 'Pick the line manager identity for the person being onboarded. The picker queries active workforce identities; the selected manager becomes the MANAGED_BY relationship target.',
    [OrganizationStepTestIds.cardTitleOrganizationAttributes]: 'Organization-specific attributes such as legal name, country, or cost center.',
    [OrganizationStepTestIds.cardTitleRelationships]: 'Relationships of this organization to other parties — for example parent or affiliate organizations.',
  },
}
